// Ensure process exists in browser bundles that don't polyfill it.
(() => {
  const g =
    (typeof window !== 'undefined' && window) ||
    (function () {
      try {
        // Fallback for non-browser envs without window/self/globalThis
        return Function('return this')();
      } catch {
        return undefined;
      }
    })();
  if (!g) return;

  if (typeof g.process === 'undefined') {
    g.process = { env: {} };
  } else if (typeof g.process.env === 'undefined') {
    g.process.env = {};
  }

  if (g.console) {
    g.console.log('[shim] process shim in entry executed');
  }
})();
